<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Géneros</h5>
        </div>
        <emt-form ref="area-form" v-bind:resource="config.api + '/gender/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="gender-grid" v-bind:resource="config.api + '/gender/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-gender',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre',
                    'placeholder': 'Ingrese nombre de género',
                    'value': null,
                    'maxlength': '20',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Nombre',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': null,
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/Genero/',
            deleteUrl: Config.api + '/Genero/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['gender-grid'].reload()
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-gender.vue?01250050